var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unit-energy"},[_c('title-one',{staticClass:"m-top",attrs:{"title":_vm.title || '',"ps-txt":_vm.psTitle || ''}}),_c('div',{staticClass:"rank-four left"},[_c('wh-echarts',{attrs:{"id":'leftFour',"option":_vm.option}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }